/**
 * pilot-api への fetch。
 *
 * 以前はどの呼び出しにも認証ヘッダが付いておらず、ログインは
 * localStorage に文字列を置くだけの見せかけだった（サーバー側も
 * 検証していなかったので、実際に誰でも叩けていた）。
 *
 * 呼び出し側を 4 箇所それぞれ直すのではなくここに寄せているのは、
 * 新しい呼び出しを足した人がヘッダを付け忘れる余地を無くすため。
 */

export const AUTH_KEY = 'pilot-authenticated';

export function getToken(): string | null {
  return localStorage.getItem(AUTH_KEY);
}

export function clearToken(): void {
  localStorage.removeItem(AUTH_KEY);
}

/**
 * トークンは期限付き（既定 12 時間）。切れたあと画面が
 * 「読み込めません」を出し続けるだけだと原因が分からないので、
 * 401 を受けたらトークンを捨ててログイン画面に戻す。
 */
export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const token = getToken();
  const headers = new Headers(init.headers);
  if (token) headers.set('Authorization', `Bearer ${token}`);

  const res = await fetch(path, { ...init, headers });

  if (res.status === 401) {
    clearToken();
    window.location.reload();
  }

  return res;
}
